import Validator from 'validatorjs'
import {app} from './app'

window.$ = window.jQuery = require('jquery')

// require('headroom.js/dist/jQuery.headroom.min.js')
require('animate.css')
require('aos/dist/aos.css')
require('fullpage.js/dist/jquery.fullpage.min.css')
require('fullpage.js/dist/jquery.fullpage.min.js')

require('vue-fullpage/vue-fullpage.css')
require('slick-carousel/slick/slick.css')
require('material-photo-gallery/dist/css/material-photo-gallery.css')
// require('material-photo-gallery/dist/js/material-photo-gallery.js')
require('date-format-lite')
Date.masks.default = 'YYYY-MM-DD'
require('./styles/main.scss')

window.toastr = require('toastr')
window.toastr.options = {
  'escapeHtml': true,
  'closeButton': false,
  'debug': false,
  'newestOnTop': false,
  'progressBar': true,
  'positionClass': 'toast-top-right',
  'onclick': null,
  'showDuration': '500',
  'hideDuration': '1000',
  'timeOut': '5000',
  'extendedTimeOut': '1000',
  'showEasing': 'swing',
  'hideEasing': 'linear',
  'showMethod': 'fadeIn',
  'hideMethod': 'fadeOut'
}

Validator.useLang('es')

Validator.register('phone', (value) => { return value.match(/^\+{0,1}[0-9;\- ]{0,16}$/) }, 'Ingrese su número correctamente.')
Validator.register('name', (value) => { return value.match(/^[a-zA-ZñáéíóúÑÁÉÍÓÚüÜ;\- ]+$/) }, 'Este campo sólo acepta texto.')

let messages = Validator.getMessages('es')
messages.required = 'Por favor complete este campo!'
messages.email = 'Este no es una dirección de email correcta.'
messages.min = 'Ingrese un valor mayor o igual a :min.'
messages.url = 'Esta no es una url correcta.'
messages.integer = 'Este campo solo acepta números.'
Validator.setMessages('es', messages)

/* eslint-disable */
const aos = require('aos/dist/aos.js')
new aos.init({
  offset: 100,
  delay: 0,
  startEvent: 'DOMContentLoaded'
})
/* eslint-enable */
app.$mount('#root')



// WEBPACK FOOTER //
// ./src/main.js